/* global  */ // tUrl等のグローバル変数を宣言する

import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

// ページ遷移時アニメーション
$(window).on('load', function () {
  $('body').removeClass('js-pageMoving')
  if ($('.js-mv')[0]) {
    $('.js-mv').addClass('active')
  }
})
// ブラウザバック時
history.replaceState(null, document.getElementsByTagName('title')[0].innerHTML, null)
window.addEventListener('popstate', function (e) {
  $('body').removeClass('js-pageMoving')
  if ($('.js-mv')[0]) {
    $('.js-mv').addClass('active')
  }
})
$('a:not([href^="#"]):not([target])').on('click', function (e) {
  e.preventDefault()
  const url = $(this).attr('href')
  if (url !== '') {
    $('body').addClass('js-pageMoving')
    setTimeout(function () {
      window.location = url
    }, 700)
  }
  return false
})

// TOPアコーディオン
if (window.matchMedia('(max-width: 768px)').matches) {
  $('.js-acc-sp').on('click', function () {
    $(this).toggleClass('active')
    $(this).next().slideToggle()
  })
}

// TOP背景
if ($('.js-contents')[0]) {
  const contents = $('.js-contents')
  setBg(contents)
  $(window).on('scroll', function () {
    setBg(contents)
  })
}
function setBg(el) {
  if ($(window).scrollTop() > 100) {
    el.removeClass('on')
  } else {
    el.addClass('on')
  }
}

/*
    ######  ##       #### ########  ########
   ##    ## ##        ##  ##     ## ##
   ##       ##        ##  ##     ## ##
    ######  ##        ##  ##     ## ######
         ## ##        ##  ##     ## ##
   ##    ## ##        ##  ##     ## ##
    ######  ######## #### ########  ########
*/
// TOPお知らせ
let toNewsSlide
if (document.getElementsByClassName('js-news-slide')[0]) {
  // SP時だけスライダーにする
  let toNewsSlideActive = false
  if (window.matchMedia('(max-width:768px)').matches) {
    toNewsSlideInit()
    toNewsSlideActive = true
  }
  window.addEventListener('resize', function (e) {
    if (toNewsSlideActive && window.matchMedia('(min-width:769px)').matches) {
      toNewsSlide.destroy()
      toNewsSlideActive = false
    } else if (!toNewsSlideActive && window.matchMedia('(max-width:768px)').matches) {
      toNewsSlideInit()
      toNewsSlideActive = true
    }
  })
}
function toNewsSlideInit() {
  toNewsSlide = new Swiper('.js-news-slide', {
    // loop: true,
    spaceBetween: 20,
    centeredSlides: true,
    slidesPerView: 2,
  })
}

// TOPグループ企業
let topGroupSlide
if (document.getElementsByClassName('js-group-slide')[0]) {
  // SP時だけスライダーにする
  let topGroupSlideActive = false
  if (window.matchMedia('(max-width:768px)').matches) {
    topGroupSlideInit()
    topGroupSlideActive = true
  }
  window.addEventListener('resize', function (e) {
    if (topGroupSlideActive && window.matchMedia('(min-width:769px)').matches) {
      topGroupSlide.destroy()
      topGroupSlideActive = false
    } else if (!topGroupSlideActive && window.matchMedia('(max-width:768px)').matches) {
      topGroupSlideInit()
      topGroupSlideActive = true
    }
  })
}
function topGroupSlideInit() {
  topGroupSlide = new Swiper('.js-group-slide', {
    loop: true,
    spaceBetween: 20,
    slidesPerView: 1.3,
    pagination: {
      el: '.group__nav__pagination',
      type: 'fraction',
      formatFractionCurrent: function (number) {
        if (number < 10) {
          return '0' + number
        } else {
          return number
        }
      },
      formatFractionTotal: function (number) {
        if (number < 10) {
          return '0' + number
        } else {
          return number
        }
      },
    },
  })
}

/*
  ######## ########  ##     ## ##    ## ##    ##  #######
     ##    ##     ## ##     ## ####  ## ##  ##   ##     ##
     ##    ########  ##     ## ## ## ## #####     #######
     ##    ##   ##   ##     ## ##  #### ##  ##   ##     ##
     ##    ##     ##  #######  ##    ## ##    ##  #######
*/
function trunk8() {
  $('.js-t8.line2').trunk8({
    // 指定要素に行数制限をかける
    lines: 2,
    fill: '...',
  })
  $('.js-t8.line1').trunk8({
    // 指定要素に行数制限をかける
    lines: 1,
    fill: '...',
  })
}
if ($('.js-t8')[0]) {
  // 要素を検出したら実行
  trunk8()
  $(window).on('load resize ', function () {
    trunk8()
  })
}

/*
  #######  #######  ########  ##     ##
  ##      ##     ## ##     ## #### ####
  #####   ##     ## ########  ## ### ##
  ##      ##     ## ##   ##   ##     ##
  ##       #######  ##     ## ##     ##
*/
// フォーム
$('.footerForm__radio__input').on('change', function () {
  $(this).parent('label').addClass('checked')
  $(this).parents('.mwform-radio-field').siblings('.mwform-radio-field').children('label').removeClass('checked')
})
$('.footerForm__check__input').on('change', function () {
  $(this).parent('label').toggleClass('checked')
})
if ($('[name="investment"]:checked').val() === 'はい') {
  $('[name="investment"][value="はい"]').parent('label').addClass('checked')
} else if ($('[name="investment"]:checked').val() === 'いいえ') {
  $('[name="investment"][value="いいえ"]').parent('label').addClass('checked')
}
if ($('[name="start"]:checked').val() === 'はい') {
  $('[name="start"][value="はい"]').parent('label').addClass('checked')
} else if ($('[name="start"]:checked').val() === 'いいえ') {
  $('[name="start"][value="いいえ"]').parent('label').addClass('checked')
}

$('.footerForm__ok__input').on('change', function () {
  $(this).parent('label').toggleClass('checked')
})
if ($('.footerForm__ok__input:checked').val() === '個人情報保護方針に同意する。') {
  $('.footerForm__ok__input').parent('label').addClass('checked')
}

/*
        ##  ######          #### ##    ##
        ## ##                ##  ####  ##
        ##  ######  #######  ##  ## ## ##
  ##    ##       ##          ##  ##  ####
   ######   ######          #### ##    ##
*/
if (document.getElementsByClassName('js-in')[0]) {
  // 画面に入った監視対象に.animatedを付加
  // Intersection Observer
  intObs()
}
function intObs() {
  let rootMargin = '-10px 0px'
  if (window.matchMedia('(max-width:768px)').matches) {
    //SPは検出を早くする
    rootMargin = '100px 0px'
  }
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-in')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const entryItem = entry.target
        entryItem.classList.add('active')
        observer.unobserve(entryItem) // 監視対象から外す
      }
    }
  }
}
